/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">

      <v-card style="margin:auto;" width="1200" >
        <v-container   style="background-color:#006699; color:white;">
      <div>
         <span>Novo Catálogo</span>
         <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs"
            v-on="on" style="float:right;color:white;">info</v-icon>
        </template>
        <span>Clique aqui para saber como criar um novo Produto</span>
      </v-tooltip>

      </div>
      <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>

<!-- ====================================================== DIALOGO INFORMATIVO ==================================================== -->
  <!-- ======================== MODAL - ADD NOVO PREÇO ============================================= -->
              <template>
               <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="800px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Novo Preço</span>
                    </v-card-title>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="12">
                            <v-text-field v-model="precoSemIva" v-money="money" @blur="ObterPrecoDescricao()" :rules="ruleTextRequired" label="Preço de Venda"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="margemPreco" :rules="ruleNumberNObrigatorio" label="Margem( % )"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                               <v-text-field v-model="valorDescricao" :disabled="true" label="Preço por compreensão"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select
                              :items="taxa_iva"
                              v-model="taxa_ivaPrecoSelected"
                              item-value="percentagem"
                              item-text="descricao"
                              @change="SelecionaIvaPreco()"
                              filled
                              label="IVA( % )*"
                            ></v-select>
                          </v-col>
                           <v-col cols="12" sm="6" md="6">
                            <v-select
                              :items="descricao_isencao_ivaprecoFiltered"
                              v-model="motivoIsencao"
                              item-text="descricao"
                              :disabled="disabilita_ivaPreco"
                              filled
                              label="Motivo de isenção*"
                            ></v-select>
                          </v-col>
                           <v-col cols="12" sm="6" md="12">
                            <v-text-field :rule="ruleNumber" :disabled="true" v-model="precoComIva" label="Preço com IVA"></v-text-field>
                            <v-switch v-model="predifinido"  label="Predefinido"></v-switch>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
  </v-form>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" color="green darken-1" :disabled="!valid"  @click="savePreco()">Guardar</v-btn>
                    <v-btn    @click="dialog = false">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>
  <!-- ==========================================FIM DO MODAL NOVO PRECO ============================================ -->
  <!-- ======================== MODAL - ADD NOVO PREÇO ============================================================== -->
              <template>
              <v-row justify="center">
                <v-dialog v-model="dialogTaxa" persistent max-width="600px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Novo Taxa</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="10">
                            <v-select
                              :items="items"
                              :disabled="true"
                              filled
                              label="Taxa"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="2">
                              <v-btn :disabled="true" small fab dark color="indigo">
                                <v-icon dark>add</v-icon>
                              </v-btn>
                          </v-col>
                          <v-col cols="12" sm="6" md="10">
                            <v-select
                              :items="items"
                              filled
                              label="Descrição"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="2">
                              <v-btn small fab dark color="indigo">
                                <v-icon dark>add</v-icon>
                              </v-btn>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field :disabled="true" label="Código"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field :disabled="true" label="Valor"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-switch  label="Sujeito a IVA"></v-switch>
                         </v-col>
                         <v-col cols="12" sm="6" md="8"></v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-switch  label="Isento a IVA"></v-switch>
                         </v-col>
                         <v-col cols="12" sm="6" md="8">
                            <v-select
                              :items="items"
                              :disabled="true"
                              filled
                              label="Não Definido"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" color="green darken-1"   @click="dialogTaxa = false">Guardar</v-btn>
                    <v-btn    @click="dialogTaxa = false">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
              </template>
  <!-- ==========================================FIM DO MODAL ========================================= -->
  <!-- ======================== MODAL - ADD NOVO GRUPO-FAMILIA ======================================== -->
              <template>
              <v-row justify="center">
                <v-dialog v-model="dialogGrupo" persistent max-width="800px">
  <v-form
    ref="formg"
    v-model="validg"
    lazy-validation
  >
                  <v-card>
                    <v-card-title>
                      <span class="headline">Novo Grupo/Familia</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>

                        <v-row>
                            <v-col cols="12" sm="6" md="9">
                                <v-text-field v-model="editeItemGrupo.codigo" :rules="ruleRequired" :disabled="!personalizar" label="Código"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-switch v-model="personalizar" label="Personalizar"></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                                <v-text-field v-model="editeItemGrupo.descricao" :rules="ruleRequired" label="Nome"></v-text-field>
                            </v-col>
                        </v-row>

                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" color="green darken-1" :disabled="!validg"   @click="SaveGrupo()">Guardar</v-btn>
                      <v-btn    @click="dialogGrupo = false">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
  </v-form>
                </v-dialog>
              </v-row>
              </template>
  <!-- ==========================================FIM DO MODAL ========================================= -->
  <v-row>
    <v-col cols="12" sm="6" md="1"></v-col>
  <v-col cols="12" sm="6" md="10">
    <v-text-field :rules="ruleRequired" :disabled="true" v-model="descricaoProduto" label="Nome do Produto*"></v-text-field>
  </v-col>
  </v-row>
        <v-tabs
          v-model="tab"
          background-color="#006699"
          dark
          color="white"
        >
          <v-tab
            v-for="item in items"
            :key="item.tab"
            :disabled="(item.id === 1 && !valid)"
            @click="TabIndexToZero(item.id)"
          >
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-alert
          v-model="alert"
          dismissible
          :type="alertType"
          border="left"
          :icon="iconAlert"
          transition="scale-transition"
          :style="colorAlert"
          elevation="2"
          colored-border
        >
        {{msgAlert}}
      </v-alert>
        <v-tabs-items v-model="tab">
    <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
          <!-- ================ PRIMEIRO TAB   GERAL ============ ======================================= -->
          <v-tab-item>
            <v-card flat>
                  <v-card-text>
                    <v-container>
                        <div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>
                      <table style="width:100%;">
                        <tr>
                          <td  style="width:70%;">

                                            <v-row>
                                              <v-col cols="12" sm="6" md="6">
                                                <v-select
                                                    :items="tipoProdutos"
                                                    item-text="descricao"
                                                    item-value="pkTipoProduto"
                                                    :rules="ruleRequired"
                                                    v-model="tipoProdutoSelected"
                                                    label="Tipo de Produto"
                                                    @change="SelecionaTipoServico()"
                                                    filled
                                                ></v-select>
                                              </v-col>
                                              <v-col cols="12" sm="6" md="6">
                                                <v-select
                                                    v-model="mercadoriaSelected"
                                                    :items="mercadoriasFiltered"
                                                    :disabled="mercadoria_disable"
                                                    :rules="ruleRequired"
                                                    item-value="pkMercadoria"
                                                    item-text="mercadoria"
                                                    label="Mercadoria"
                                                    filled
                                                ></v-select>
                                              </v-col>
                                              <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="codigoBarraSelected" @blur="VerificaCodigoExistente()" :rules="ruleNumber" label="Código de Barra"></v-text-field>
                                              </v-col>
                                              <v-col cols="12" sm="6" md="6">
                                                <v-select
                                                    :items="armazem"
                                                    v-model="armazemSelected"
                                                    :rules="ruleRequired"
                                                    item-value="pkArmazem"
                                                    item-text="descricao"
                                                    label="Armazém ou Loja disponível"
                                                    filled
                                                ></v-select>
                                              </v-col>
                                              <v-col cols="12" sm="6" md="6">
                                                <v-text-field :rules="ruleRequired" v-model="descricaoReduzida" label="Descrição reduzida"></v-text-field>
                                              </v-col>
                                              <v-col cols="12" sm="6" md="6">
                                                <v-select
                                                    :items="especificacao"
                                                    v-model="especificacaoProdutoSelected"
                                                    :rules="ruleRequired"
                                                    item-value="pkArmazem"
                                                    item-text="descricao"
                                                    label="Especificação do Produto"
                                                    @change="SelecionaEspecProduto()"
                                                    filled
                                                ></v-select>
                                              </v-col>
                                            </v-row>
                                            <span style="font-size:20px;font-weight:bold;">Família/Stock</span>
                                            <div  style="border:1px solid black;">
                                                <v-row>
                                                     <v-col cols="12" sm="6" md="3">
                                                        <v-select
                                                            v-model="familiaSelected"
                                                            item-value="pkFamiliaProduto"
                                                            :items="familiaProduto"
                                                            :rules="ruleRequired"
                                                            item-text="descricao"
                                                            label="Familia"
                                                            filled
                                                        ></v-select>
                                                    </v-col>
                                                     <v-col cols="12" sm="6" md="1">
                                                       <v-btn  @click="showDialogGrupo()" class="btn_add_align" small fab dark color="indigo">
                                                         <v-icon dark>add</v-icon>
                                                       </v-btn>
                                                  </v-col>
                                                  <v-col cols="12" sm="6" md="3">
                                                    <v-tooltip bottom>
                                                      <template v-slot:activator="{ on, attrs }">
                                                        <v-select
                                                            v-model="controleStockSelected"
                                                            item-value="id"
                                                            :items="controleStock"
                                                            :rules="ruleRequired"
                                                            item-text="descricao"
                                                            label="Controle de Stock"
                                                            filled
                                                            @change="SelecionaControleStock()"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        ></v-select>
                                                      </template>
                                                      <span>Define o valor para receber um alerta de baixa de stock</span>
                                                    </v-tooltip>
                                                    </v-col>
                                                  <v-col cols="12" sm="6" md="2">
                                                    <v-tooltip bottom>
                                                      <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-bind="attrs"
                                                          v-on="on" :disabled="disabledStocksFields"  :rules="(controleStockSelected === 1) ? '' : ruleNumber" v-model="stockMinimo" label="Stock Mínimo"></v-text-field>
                                                      </template>
                                                      <span>Define o valor para receber um alerta de baixa de stock</span>
                                                    </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="2">
                                                      <v-tooltip  bottom>
                                                      <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field :disabled="disabledStocksFields" v-bind="attrs"  v-on="on"
                                                         :rules="(controleStockSelected === 1) ? '' : ruleNumber" v-model="stockMaximo" label="Stock Máximo"></v-text-field>
                                                      </template>
                                                      <span>Define o valor para receber um alerta de excesso de stock</span>
                                                    </v-tooltip>

                                                    </v-col>
                                                </v-row>
                                            </div>

                                  </td>

                                  <td>
                                      <table style="width:100%;">
                                         <tr>
                                            <td style="width:95%;">
                                                <div style="border:1px solid black;width:250px;height:250px;margin-left:26px;">
                                                   <v-img style="width:250px;height:250px" :src="imageData" aspect-ratio="1.7"></v-img>
                                                </div>
                                            </td>
                                            <td>
                                                   <input @change="previewImage" type="file" ref="file" style="display: none">
                                                    <v-btn @click="$refs.file.click()" class="mx-2 btn_space" small fab dark color="primary">
                                                        <v-icon dark>add_a_photo</v-icon>
                                                    </v-btn>
                                                    <v-btn @click="imageData = ''" class="mx-2 btn_space" small fab dark color="primary">
                                                        <v-icon dark>remove</v-icon>
                                                    </v-btn>

                                            </td>
                                         </tr>
                                      </table>
                                     <v-card-actions style="margin-top:250px;margin-left:50px;">
                                      <v-btn style="color:white;" color="green darken-1" :disabled="!valid || codigoRepetido"    @click="Continuar()">Continuar</v-btn>
                                      <v-btn    @click="resetValidation()">Limpar</v-btn>
                                    </v-card-actions>
                                  </td>
                              </tr>
                            </table>
                    </v-container>
                  </v-card-text>

            </v-card>
          </v-tab-item>
    </v-form>
    <!-- ================ FIM - SEGUNDO TAB e Inicio 2 Tab ======================================= -->
      <v-tab-item>
            <v-card flat>

  <v-form
    ref="form1"
    v-model="valid1"
    lazy-validation
  >
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-select
                                :items="DefinirPrecoVenda"
                                v-model="DefinirPrecoVendaSelected"
                                item-text="descricao"
                                item-value="id"
                                label="Definir Preço de venda"
                                @change="SelecionaDefinirPrecoVenda()"
                              ></v-select>
                          </v-col>
                           <v-col cols="12" sm="6" md="4">
                              <v-select
                                :items="Unidades"
                                v-model="unidadeSelecionada"
                                item-text="descricao"
                                item-value="id"
                                label="Definir preço por:"
                                @click="SelecionaUnidade()"
                                return-object
                              ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" v-if="showFieldPreco">
                            <v-select
                                :items="TipoPrecoVenda"
                                v-model="tipoPrecoSelecionada"
                                item-text="descricao"
                                :disabled="disabledPrecoFields"
                                item-value="id"
                                label="Calculo do Preço de venda"
                                @change="CalculoPrecoVenda()"
                              ></v-select>
                          </v-col>
                           <v-col cols="12" sm="6" md="2" v-if="!disableMargem">
                            <v-text-field v-model="custoCompra" :disabled="disableMargem || disabledPrecoFields" v-money="money" :rules="ruleTextRequired" label="Custo do Produto"></v-text-field>
                          </v-col>
                           <v-col cols="12" sm="6" md="2" v-if="!disableMargem">
                            <v-text-field v-model="margemPrecoAutomatico" @blur="CalculoPrecoVendaAutomatico()" :disabled="disableMargem || disabledPrecoFields" :rules="ruleNumberNObrigatorio" label="Margem(%)de Lucro"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" v-if="disableMargem && showFieldPreco">
                            <v-text-field v-model="margemPreco" :disabled="disableMargem || disabledPrecoFields" :rules="ruleNumberNObrigatorio" label="Margem( % )"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" v-if="!disableMargem">
                            <v-text-field v-model="precoSemIvaMargem"  :disabled="!disableMargem || disabledPrecoFields"  @blur="ObterPrecoDescricao()" :rules="(DefinirPrecoVendaSelected === 1)?'':ruleTextRequired" label="Preço de Venda"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" v-if="disableMargem && showFieldPreco">
                            <v-text-field v-model="precoSemIva"  :disabled="!disableMargem || disabledPrecoFields" v-money="money" @blur="ObterPrecoDescricao()" :rules="ruleTextRequired" label="Preço de Venda"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" v-if="showFieldPreco">
                               <v-text-field v-model="valorDescricao"  :rules="(DefinirPrecoVendaSelected === 1) ? 1 : ruleRequired"  :disabled="true" label="Preço por compreensão"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select
                              :items="taxa_iva"
                              v-model="taxa_ivaPrecoSelected"
                               item-value="percentagem"
                              item-text="descricao"
                              @change="SelecionaIvaPreco()"
                              filled
                              label="IVA( % )*"
                            ></v-select>
                          </v-col>
                           <v-col cols="12" sm="6" md="6">
                            <v-select
                              :items="descricao_isencao_ivaprecoFiltered"
                              v-model="motivoIsencao"
                              item-text="descricao"
                              :disabled="disabilita_ivaPreco"
                              filled
                              label="Motivo de isenção*"
                            ></v-select>
                          </v-col>
                           <v-col cols="12" sm="6" md="12" v-if="showFieldPreco">
                            <v-text-field :rule="ruleNumber" :rules="(DefinirPrecoVendaSelected === 1) ? 1 : ruleRequired" :disabled="true" v-model="precoComIva" label="Preço com IVA"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
    </v-form>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" color="green darken-1" :disabled="!valid1 || !valid"  @click="Continuar2()">Continuar</v-btn>
                    <v-btn    @click="tab=0">Voltar</v-btn>
                    </v-card-actions>
                  </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>

  <v-form
    ref="form2"
    v-model="valid2"
    lazy-validation
  >
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-select
                                :items="DefinirPrecoVenda"
                                v-model="definirSubstituto"
                                item-text="descricao"
                                item-value="id"
                                label="Definir produto substituto?"
                              ></v-select>
                          </v-col>
                           <v-col cols="12" sm="6" md="8" v-if="definirSubstituto === 2">
                             <v-combobox
                              v-model="produtoSubstitutoModel"
                              :items="produtosSubstitutos"
                              hide-selected
                              item-text="produto"
                              label="Selecione o(s) produto(s) substituto(s)"
                              multiple
                              return-object
                              @click="CarregaProdutos()"
                              >
                             </v-combobox>

                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
    </v-form>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" color="green darken-1" :disabled="!valid1 || !valid || !valid2"  @click="saveProduto()">Actualizar</v-btn>
                    <v-btn    @click="tab=1">Voltar</v-btn>
                    </v-card-actions>
                  </v-card>
          </v-tab-item>
  <!-- ================ FIM - PREÇOS ======================================= -->
        </v-tabs-items>
      </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import utilitarios from '../../plugins/utilitarios'
const numero = require('numero-por-extenso')
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    valorDescricao: '',
    price: 0,
    dialogInformativo: false,
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    tab: null,
    items: [
      { tab: 'Geral', disabilita: false, content: 'Tab 1 Content', id: 0 },
      { tab: 'Preços', disabilita: false, content: 'Tab 2 Content', id: 1 },
      { tab: 'Configurações adicionais', disabilita: false, content: 'Tab 2 Content', id: 3 }
    ],
    msgAlert: '',
    alert: false,
    colorAlert: 'red',
    iconAlert: 'done',
    alertType: 'success',
    valor: '',
    custoCompra: '',
    overlay: false,
    Precoautomatico: false,
    precoSemIvaMargem: 0,
    produtosSubstitutos: [],
    definirSubstituto: '',
    margemPrecoAutomatico: 0,
    disabledPrecoFields: false,
    codigoRepetido: false,
    personalizar: false,
    especificacaoProdutoSelected: null,
    DefinirPrecoVendaSelected: null,
    tipoProdutoSelected: null,
    mercadoriaSelected: null,
    familiaSelected: null,
    mercadoria_disable: false,
    taxa_ivaPrecoSelected: null,
    taxaIvaCompraSelected: null,
    taxaIvaVendaSelected: null,
    disabilita_ivaPreco: false,
    disabilita_ivaVenda: false,
    disabilita_ivaCompra: false,
    tipoPrecoSelecionada: null,
    controleStockSelected: null,
    codigoProduto: null,
    descricaoProduto: null,
    precoComIvaInteiro: null,
    codigoBarraSelected: '',
    descricaoReduzida: '',
    armazemSelected: '',
    motivoIsencao: '',
    margemPreco: '',
    precoSemIva: 0,
    precoComIva: '',
    precoCustoSelected: '',
    disabledStocksFields: true,
    predifinido: false,
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: 'Nº do Bi',
    validg: true,
    valid1: true,
    valid: true,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    imageData: '',
    turmasAll: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    armazem: [],
    taxa_iva: [],
    familiaProduto: [],
    mercadorias: [],
    tipoProdutos: [],
    descricao_isencao_ivaprecoFiltered: [],
    descricao_isencao_compraFiltered: [],
    descricao_isencao_ivaFiltered: [],
    descricao_isencao_iva: [],
    municipiosFiltered: [],
    mercadoriasFiltered: [],
    precosExtensao: [],
    tabelas_preco: [],
    produtoSubstitutoModel: [],
    model: [],
    searchInDb: '',
    stockMinimo: null,
    stockMaximo: null,
    unidadeSelecionada: null,
    search: null,
    showFieldPreco: true,
    disableMargem: true,
    estudantes: [],
    servicos: [],
    dialogGrupo: false,
    valid2: true,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    controleStock: [
      { id: 1, descricao: 'Não' },
      { id: 2, descricao: 'Sim' }
    ],
    DefinirPrecoVenda: [
      { id: 1, descricao: 'Não' },
      { id: 2, descricao: 'Sim' }
    ],
    especificacao:
    [
      { id: 1, descricao: 'Venda Normal' },
      { id: 2, descricao: 'Oferta' }
    ],
    Unidades: [
      { id: 1, descricao: 'Unidade' },
      { id: 2, descricao: 'Kg' }
    ],
    TipoPrecoVenda: [
      { id: 1, descricao: 'Manual' },
      { id: 2, descricao: 'Automático' }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 100 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleNumberNObrigatorio: [
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Preço descrição',
        align: 'start',
        sortable: false,
        value: 'name'
      },
      { text: 'Margem', value: 'calories' },
      { text: 'Preço sem IVA', value: 'fat' },
      { text: 'IVA', value: 'carbs' },
      { text: 'Modo de isenção', value: 'protein' },
      { text: 'Preço com IVA', value: 'iron' },
      { text: 'Stock Mínimo', value: 'stock_min' },
      { text: 'Stock Máximo', value: 'stock_max' },
      { text: 'Predifinido', value: 'iron' }
    ],
    headersPreco: [
      {
        text: 'Preço descrição',
        align: 'start',
        sortable: false,
        value: 'descricaoPreco'
      },
      { text: 'Margem', value: 'margem' },
      { text: 'Preço sem IVA', value: 'precoSemIva' },
      { text: 'IVA', value: 'iva' },
      { text: 'Modo de isenção', value: 'motivoIsencao' },
      { text: 'Preço com IVA', value: 'precoComIva' },
      { text: 'Stock Mínimo', value: 'stock_min' },
      { text: 'Stock Máximo', value: 'stock_max' },
      { text: 'Predifinido', value: 'predifinido' }
    ],
    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editeItemGrupo: {
      codigo: '',
      descricao: '',
      pkGrupo: 0
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },

    tab (val) {
      console.log(val)
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.overlay = true
    this.initializeTipoProdutos()
    this.initializeMercadoria()
    this.initializeArmazem()
    this.initializeFamiliaProduto()
    this.initializeTaxaIva()
    this.initializeIsencaoIva()
    setTimeout(() => {
      this.initializePrecosDescricao().then(() => {
        this.preencheCampos()
      })
    }, 2000)
  },

  methods: {
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },

    async initializeTipoProdutos () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.tipoProdutos = await axios
          .get('/tipoProdutoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    async initializeMercadoria () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.mercadorias = await axios
          .get('/mercadoriaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    async CarregaProdutos () {
      try {
        //   let  payload =""
        this.overlay = true
        this.produtosSubstitutos = await axios
          .get('/produtosFindall-substituto')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeArmazem () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.armazem = await axios
          .get('/armazemFindall')
          .then(res => res.data)
        console.log(this.armazem)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeFamiliaProduto () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.familiaProduto = await axios
          .get('/FamiliaProdutoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    async initializeTaxaIva () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.taxa_iva = await axios
          .get('/TaxaIvaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeIsencaoIva () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.descricao_isencao_iva = await axios
          .get('/IsencaoIvaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async  VerificaCodigoExistente () {
      try {
        //   let  payload =""
        this.isLoading = true
        let result = await axios
          .get('/verificaCodigoBarra/' + this.codigoBarraSelected)
          .then(res => res.data)
        if (result.length) {
          this.codigoRepetido = true
          this.alert = true
          this.colorAlert = 'color:red;'
          this.iconAlert = 'warning'
          this.alertType = 'error'
          this.msgAlert = 'Código de Barra Existente!'
          setTimeout(() => {
            this.alert = false
          }, 4000)
        } else {
          this.codigoRepetido = false
        }
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializePrecosDescricao () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.precosExtensao = await axios
          .get('/precosExtensaoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    async SaveGrupo () {
      if (this.$refs.formg.validate()) {
        let params =
          {
            pkFamilia: 0,
            descricao: this.editeItemGrupo.descricao,
            codigo: this.editeItemGrupo.codigo
          }

        try {
        //   let  payload =""
          this.isLoading = true
          let result = await axios
            .post('/FamiliaInsertUpdate', params)
            .then(res => res.data)
          if (result.affectedRows >= 0) {
            this.initializeFamiliaProduto().then(() => {
              this.familiaSelected = this.familiaProduto[this.familiaProduto.length - 1]
              this.dialogGrupo = false
              this.editeItemGrupo.codigo = ''
              this.editeItemGrupo.descricao = ''
            })
          }
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    Continuar () {
      if (this.$refs.form.validate()) {
        this.tab = 1
      }
    },

    Continuar2 () {
      if (this.$refs.form1.validate()) {
        this.tab = 2
      }
    },

    TabIndexToZero (id) {

    },

    SelecionaUnidade () {

    },

    SelecionaIvaVenda () {
      if (this.taxaIvaVendaSelected !== null) {
        if (this.taxaIvaVendaSelected === 0) {
          this.descricao_isencao_ivaFiltered = this.descricao_isencao_iva
          this.disabilita_ivaVenda = false
        } else {
          this.disabilita_ivaVenda = true
          this.descricao_isencao_ivaFiltered = []
        }
      }
    },

    SelecionaControleStock () {
      if (this.controleStockSelected === 1) {
        this.disabledStocksFields = true
      } else {
        this.disabledStocksFields = false
      }
    },

    SelecionaDefinirPrecoVenda () {
      if (this.DefinirPrecoVendaSelected === 1) {
        this.disabledPrecoFields = true
        this.showFieldPreco = false
        // Faz o reset da combobox de seleção do calculo do preço
        this.disableMargem = true
        this.tipoPrecoSelecionada = this.TipoPrecoVenda[0]
        // Faz o reset da combobox --- Fim
        this.LimpaCamposPreco()
      } else if (this.DefinirPrecoVendaSelected === 2) {
        this.disabledPrecoFields = false
        this.showFieldPreco = true
      }
    },

    showDialogGrupo () {
      this.editeItemGrupo.codigo = this.descricaoProduto + ' - ' + (parseInt(this.familiaProduto[this.familiaProduto.length - 1].pkFamiliaProduto) + 1)
      this.dialogGrupo = true
    },

    ObterPrecoDescricao () {
      let result = utilitarios.MoneyValueToInteger(this.precoSemIva)
      let valor = numero.porExtenso(result)
      valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
      this.valorDescricao = valor + ' Kwanza(s)'
    },

    SelecionaIvaCompra () {
      if (this.taxaIvaCompraSelected !== null) {
        if (this.taxaIvaCompraSelected === 0) {
          this.descricao_isencao_compraFiltered = this.descricao_isencao_iva
          this.disabilita_ivaCompra = false
        } else {
          this.disabilita_ivaCompra = true
          this.descricao_isencao_compraFiltered = []
        }
      }
    },

    SelecionaIvaPreco () {
      if (this.taxa_ivaPrecoSelected !== null) {
        if (this.taxa_ivaPrecoSelected === 0) {
          this.descricao_isencao_ivaprecoFiltered = this.descricao_isencao_iva
          this.disabilita_ivaPreco = false
        } else {
          this.disabilita_ivaPreco = true
          this.descricao_isencao_ivaprecoFiltered = []
        }
        this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
      }
    },

    SelecionaEspecProduto () {
      if (this.especificacaoProdutoSelected.id === 0) {
        this.precoComIvaInteiro = 0
        this.precoSemIva = 0
        this.margemPreco = 0
        this.taxa_ivaPrecoSelected = 0
        this.valorDescricao = 'Zero Kwanza'
      }
    },
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
      this.Limpar()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    SelecionaTipoServico () {
      if (this.tipoProdutoSelected !== null) {
        this.mercadoriasFiltered = this.mercadorias.filter(f => f.fk_tipoProduto === this.tipoProdutoSelected)
        console.log(this.mercadorias)

        this.mercadoria_disable = (this.tipoProdutoSelected !== 1)
      }
    },
    savePreco () {
      if (this.$refs.form.validate()) {
        let params =
          {
            descricaoPreco: this.valorDescricao,
            margem: this.margemPreco,
            precoSemIva: this.precoSemIva,
            iva: this.taxa_ivaPrecoSelected,
            motivoIsencao: this.motivoIsencao,
            predifinido: this.predifinido,
            precoComIva: this.precoComIva
          }

        this.tabelas_preco.push(params)
        this.dialog = false
      }
    },

    CalculoPrecoVenda () {
      if (this.tipoPrecoSelecionada === 1) {
        this.disableMargem = true
        this.Precoautomatico = false
      } else {
        this.disableMargem = false
        this.Precoautomatico = true
      }
    },

    async saveProduto () {
      if (this.$refs.form1.validate() && this.$refs.form.validate()) {
        // Definição das variaveis
        this.overlay = true
        let precoVenda = (this.Precoautomatico) ? this.precoSemIvaMargem : this.precoSemIva

        let params =
        {
          descricao: this.descricaoProduto,
          descricaoReduzida: this.descricaoReduzida,
          codigoBarra: this.codigoBarraSelected,
          armazem: this.armazemSelected,
          tipoProduto: this.tipoProdutoSelected,
          mercadoria: this.mercadoriaSelected,
          familia: (this.familiaSelected.pkFamiliaProduto !== undefined) ? this.familiaSelected.pkFamiliaProduto : this.familiaSelected,
          precoComIva: this.precoComIvaInteiro,
          precoSemIva: (this.DefinirPrecoVendaSelected === 1) ? null : ((precoVenda !== 0) ? utilitarios.MoneyValueToInteger(precoVenda) : 0),
          margem: (this.Precoautomatico) ? this.margemPrecoAutomatico : this.margemPreco,
          iva: this.taxa_ivaPrecoSelected,
          isencao: this.motivoIsencao,
          descricaoPreco: this.valorDescricao,
          pkProduto: this.$store.state.produto.pkProduto,
          especificacaoProduto: this.especificacaoProdutoSelected,
          stockMinimo: (this.controleStockSelected === 1) ? null : this.stockMinimo,
          stockMaximo: (this.controleStockSelected === 1) ? null : this.stockMaximo,
          unidade: this.unidadeSelecionada,
          controleStock: this.controleStockSelected,
          precoVendaDefinido: this.DefinirPrecoVendaSelected,
          CalculoPrecoVenda: this.tipoPrecoSelecionada,
          substituto: this.produtoSubstitutoModel
        }
        try {
          //   let  payload =""
          this.isLoading = true
          let msg = await axios
            .post('/produtoAdd', params)
            .then(res => res.data)
          if (msg.affectedRows !== undefined) {
            if (msg.affectedRows >= 1) {
              this.alert = true
              this.colorAlert = 'color:green;'
              this.iconAlert = 'done'
              this.alertType = 'success'
              this.msgAlert = 'Produto registrado com sucesso!'
              this.tab = 0
              this.overlay = false
              setTimeout(() => {
                this.alert = false
                this.$router.push('/Visualizar-Produto')
              }, 2000)
              this.reset()
            } else {
              this.alert = true
              this.colorAlert = 'color:red;'
              this.iconAlert = 'warning'
              this.alertType = 'warning'
              this.msgAlert = 'Ocorreu um erro ao tentar registrar o Produto!'
              this.tab = 0
              setTimeout(() => {
                this.alert = false
              }, 2000)
            }
          } else if (msg.sqlMessage !== undefined) {
            this.alert = true
            this.colorAlert = 'color:red;'
            this.iconAlert = 'warning'
            this.alertType = 'warning'
            this.msgAlert = 'Ocorreu um erro ao tentar registrar o Produto!'
            this.tab = 0
            setTimeout(() => {
              this.alert = false
            }, 2000)
          }
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    Limpar () {
      this.descricaoProduto = ''
      this.descricaoReduzida = ''
      this.armazemSelected = ''
      this.tipoProdutoSelected = ''
      this.mercadoriaSelected = ''
      this.familiaSelected = ''
      this.tabelas_preco = []
    },

    LimpaCamposPreco () {
      this.precoComIva = ''
      this.precoComIvaInteiro = ''
      this.precoSemIvaMargem = ''
      this.precoSemIva = ''
      this.valorDescricao = ''
      this.margemPrecoAutomatico = ''
      this.margemPreco = ''
      this.motivoIsencao = ''
      this.taxa_ivaPrecoSelected = ''
      this.margem = ''
    },

    CalculaPreComIva (valor) {
      let Preco = (!this.disableMargem) ? this.precoSemIvaMargem : this.precoSemIva
      let valorIva = ((Preco === 0) ? 0 : utilitarios.MoneyValueToInteger(Preco)) * valor
      let valorFinal = ((Preco === 0) ? 0 : utilitarios.MoneyValueToInteger(Preco)) + valorIva
      this.precoComIva = valorFinal
      this.precoComIva = this.ObterValorFormatado(valorFinal)
      this.precoComIvaInteiro = valorFinal
    },
    CalculoPrecoVendaAutomatico () {
      let CustoDouble = utilitarios.MoneyValueToInteger(this.custoCompra)
      let lucro = (CustoDouble * this.margemPrecoAutomatico) / 100
      let PrecoVendaCalculado = CustoDouble + lucro
      this.precoSemIvaMargem = utilitarios.IntegerToMoneyValue(PrecoVendaCalculado)
      this.PrecoDescricao(this.precoSemIvaMargem)
    },

    PrecoDescricao (preco) {
      let result = utilitarios.MoneyValueToInteger(preco)
      let valor = numero.porExtenso(result)
      valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
      this.valorDescricao = valor + ' Kwanza(s)'
    },

    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      return formated.toString().replace('AOA', '')
    },
    preencheCampos () {
      let produto = this.$store.state.produto
      this.descricaoProduto = produto.produto
      this.codigoBarraSelected = produto.codigoBarra
      this.descricaoReduzida = produto.descricaoReduzida
      this.stockMaximo = produto.stock_max
      this.stockMinimo = produto.stock_min
      this.margemPreco = produto.margem
      this.precoSemIva = utilitarios.IntegerToMoneyValue(produto.precoSemIva)
      this.ObterPrecoDescricao()
      this.taxa_ivaPrecoSelected = this.taxa_iva.filter(i => i.percentagem === produto.iva)[0]
      if (produto.iva === 0) { this.descricao_isencao_ivaprecoFiltered = this.descricao_isencao_iva } else { this.descricao_isencao_ivaprecoFiltered = [] }
      this.motivoIsencao = this.descricao_isencao_ivaprecoFiltered.filter(f => f.descricao === produto.isencao)[0]
      this.tipoPrecoSelecionada = this.TipoPrecoVenda.filter(t => t.id === produto.calculoPrecoVenda)[0]
      this.DefinirPrecoVendaSelected = this.DefinirPrecoVenda.filter(p => p.id === produto.precoVendaDefinido)[0]
      this.unidadeSelecionada = this.Unidades.filter(u => u.id === produto.unidade)[0]
      this.tipoProdutoSelected = this.tipoProdutos.filter(t => t.pkTipoProduto === parseInt(produto.tipoProduto))[0]
      this.mercadoriasFiltered = this.mercadorias.filter(m => m.fk_tipoProduto === parseInt(produto.tipoProduto))
      this.mercadoriaSelected = this.mercadoriasFiltered.filter(m => m.descricao === produto.mercadoria)[0]
      this.armazemSelected = this.armazem.filter(a => a.descricao === produto.armazem)[0]
      this.especificacaoProdutoSelected = this.especificacao.filter(e => e.descricao === produto.especificacaoProduto)[0]
      this.familiaSelected = this.familiaProduto.filter(f => f.pkFamiliaProduto === parseInt(produto.pkFamilia))[0]
      this.controleStockSelected = this.controleStock.filter(c => c.id === parseInt(produto.controleStock))[0]
      this.overlay = false
    }
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
